
import {createSlice} from "@reduxjs/toolkit";

export const contractDrilldownSlice = createSlice({
    name: 'contractDrilldownSlc',
    initialState: {value: {id: 0, mcode: null, name: null, description: null,
        cdpDrawerState: false, csDrawerState: false,
            cdpvfGridState: false, helperState: false, dynamicHelperState: false,
            helperMode: null,


        }},
    reducers:
{
    changeContractDrilldown: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContractDrilldown } = contractDrilldownSlice.actions;

export default  contractDrilldownSlice.reducer ;
